import React from 'react'

import { EuiFormRow, EuiSelect } from '@elastic/eui'

import { CustomerOptimizationStrategy, CustomerOptimizationType } from '../../api/interfaces'

export interface ICampaignTrafficPriorityPicker {
  customerOptimizationStrategy?: CustomerOptimizationStrategy
  onOptimizationStrategyChange?: (optimizationStrategy: CustomerOptimizationStrategy) => void
}

export const CampaignTrafficPriorityPicker: React.FC<ICampaignTrafficPriorityPicker> = ({ customerOptimizationStrategy, onOptimizationStrategyChange }) => {
  const getOptimizationDescription = (optimizationType: CustomerOptimizationType): string => {
    switch (optimizationType) {
      case CustomerOptimizationType.QualityImpressions:
        return 'Deliver impressions using a curated list of high quality websites.'
      case CustomerOptimizationType.Traffic:
        return 'Maximize impressions by allowing traffic from a vast number of websites at a lower CPM.'
      case CustomerOptimizationType.Clicks:
        return 'Prioritize websites and apps with elevated click through rates.'
      default:
        return ''
    }
  }

  const optimizationOptions: { id: CustomerOptimizationType; label: string }[] = [
    {
      id: CustomerOptimizationType.QualityImpressions,
      label: 'Quality Impressions (Recommended)'
    },
    {
      id: CustomerOptimizationType.Traffic,
      label: 'Prioritize Traffic'
    },
    {
      id: CustomerOptimizationType.Clicks,
      label: 'Prioritize Clicks / CTR'
    }
  ]

  const onStrategyChange = (optimizationType: CustomerOptimizationType) => {
    if (!onOptimizationStrategyChange) {
      return
    }

    onOptimizationStrategyChange({ optimizationType: optimizationType })
  }

  return (
    <EuiFormRow label='Optimization Strategy' helpText={getOptimizationDescription(customerOptimizationStrategy?.optimizationType ?? CustomerOptimizationType.QualityImpressions)}>
      <EuiSelect options={optimizationOptions.map(option => ({ value: option.id, text: option.label }))} value={customerOptimizationStrategy?.optimizationType ?? CustomerOptimizationType.QualityImpressions} onChange={e => onStrategyChange(e.target.value as CustomerOptimizationType)} />
    </EuiFormRow>
  )
}
